import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BarChartComponent } from './bar-chart.component';
import type { BarChartParams } from './bar-chart.model';

@Component({
  selector: 'dojo-bar-chart-explain',
  standalone: true,
  imports: [BarChartComponent],
  template: `<dojo-bar-chart [params]="params()" />`,
  host: { class: 'block w-full h-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BarChartExplainComponent {
  readonly params = input.required<BarChartParams>();
}
